import { IPageItem } from '../../routes/courseDashboard/features/coursePages/CoursePageList';

export const getParent = (treeData: any, parentID: any) => {
  if (treeData.items[parentID] != null) {
    return treeData.items[parentID];
  }
  return null;
};

export const findNodeById = (nodes: IPageItem[], id: string): IPageItem | undefined => {
  for (const node of nodes) {
    if (node.key == id) return node;
    if (node.children?.length) {
      const found = findNodeById(node.children, id);
      if (found) return found;
    }
  }
  return undefined;
};

export const checkNumberOfParents = (tree: IPageItem[], destinationParentID: string): number => {
  if (!destinationParentID || destinationParentID === '0') {
    return 0;
  }

  let count = 0;
  let currentID: string | null = destinationParentID;

  while (currentID != null) {
    const parentNode = findNodeById(tree, currentID);
    if (!parentNode) break;

    count++;
    if (!parentNode.data.parentCoursePageID) break;
    currentID = parentNode.data.parentCoursePageID.toString();
  }

  return count;
};

export const checkNumberOfChildren = (node: IPageItem): number => {
  if (!node.children || node.children.length === 0) return 0;

  let maxDepth = 0;

  for (const child of node.children) {
    maxDepth = Math.max(maxDepth, 1 + checkNumberOfChildren(child));
  }

  return maxDepth;
};
